<template>
  <main
    class="col-lg-12 col-md-12 col-sm-12 p-0"
    style="display: flex; height: 100%; flex-direction: column"
    @click="ProcessClick($event)"
  >
    <!-- Main Navbar -->
    <div :class="['main-navbar', 'bg-white']">
      <d-container class="p-0">
        <d-navbar type="light" class="align-items-stretch flex-md-nowrap p-0">
          <a class="navbar-brand" href="#" style="line-height: 25px">
            <div class="d-table m-auto">
              <img
                id="main-logo"
                class="d-inline-block align-top mr-1 ml-3 auth-form__logo"
                style="max-width: 150px; height: 40px; width: 110px"
                src="@/assets/images/logos/logo-partner.svg"
                alt="Safe2Pay Logo"
                v-on:click="ClickLogo()"
              />
            </div>
          </a>
          <navbar-search />
          <navbar-nav class="d-flex ml-auto" />
          <navbar-toggle class="border-left" v-d-toggle.nav1 />
        </d-navbar>
      </d-container>
    </div>
    <!-- Header Navbar -->
    <header-navbar tag="d-collapse" id="nav1" :items="headerNavbarItems" />
    <!-- Content -->
    <slot />
    <!-- Main Footer -->
    <main-footer class="mt-5" />
  </main>
</template>

<script>
import getHeaderNavbarItems from "@/data/header-nav-items";
import MainNavbar from "@/components/layout/MainNavbar/MainNavbar.vue";
import NavbarSearch from "@/components/layout/MainNavbar/NavbarSearch.vue";
import NavbarNav from "@/components/layout/MainNavbar/NavbarNav.vue";
import NavbarToggle from "@/components/layout/MainNavbar/NavbarToggle.vue";
import HeaderNavbar from "@/components/layout/HeaderNavbar/HeaderNavbar.vue";
import MainFooter from "@/components/layout/MainFooter/MainFooter.vue";

export default {
  components: {
    MainNavbar,
    NavbarSearch,
    NavbarNav,
    NavbarToggle,
    HeaderNavbar,
    MainFooter,
  },
  data() {
    return {
      headerNavbarItems: getHeaderNavbarItems(),
      User: {
        Name: "",
        PictureUrl: "",
        Email: "",
      },
    };
  },
  mounted() {
    this.GetUserData();
    this.VerifyUserProfile();
  },
  methods: {
    GetUserData() {
      if (this.$getUserPartner()) this.User = this.$getUserPartner();
      this.ComponentKey += 1;
    },
    VerifyUserProfile() {
      if (this.$profileCode() != "1") {
        for (let i = 0; i < this.headerNavbarItems.length; i++) {
          if (
            this.headerNavbarItems[i].key != "deals" &&
            this.headerNavbarItems[i].key != "relationship"
          ) {
            this.headerNavbarItems.splice(i, 1);
            i--;
          }
        }
      }
    },
    ProcessClick(ev) {
      this.$root.$emit("PageClick", ev);
    },
    ClickLogo() {
      this.$router.push({ name: "dashboard" });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/layouts/HeaderNavigation.vue